export const PreferenceList = [
  {
    value: 'UPPER_FLOOR',
    label: 'Upper Floor',
  },
  {
    value: 'DAYLIGHT',
    label: 'Daylight',
  },
  {
    value: 'FACE_COURTYARD',
    label: 'Face Courtyard',
  },
  {
    value: 'FACE_STREET',
    label: 'Face Street',
  },
  {
    value: 'MORE_STORAGE',
    label: 'More Storage',
  },
]

export const TourCancelReasonList: string[] = [
  'Time conflict',
  'No longer interested in this property',
  'No longer available ',
  'Other reason',
]

export const TourStatusList = {
  SCHEDULED: 'scheduled',
  CANCELED: 'canceled. Feel free to reschedule anytime.',
  FINISHED: 'completed',
}

const TourTypeList = [
  {
    key: 'IN_PERSON_TOUR',
    name: 'tour',
  },
  {
    key: 'VIRTUAL_TOUR',
    name: 'virtual tour',
  },
  {
    key: 'IN_PERSON_TOUR (Group)',
    name: 'tour (Group)',
  },
  {
    key: 'VIRTUAL_TOUR (Group)',
    name: 'virtual tour (Group)',
  },
]

export const getTourTypeName = (key: string) => TourTypeList.find(item => item.key === key)?.name || '-'

interface RentPriceType {
  baseAmount: number
  discountAmount: number
  leaseTerm: number
  moveInDate: number
}
export interface RoomType {
  availableNow: boolean
  availableStatus: number
  availableStartTime: number
  tourAvailableStatus?: number
  tourAvailableStartTime?: number
  preTourEndDate: number
  preTourStartDate: number
  id: string
  name: string
  privateBathroom: boolean
  propertyId: string
  rentPriceLeaseTerm: string
  unitId: string
  rentPrice: RentPriceType
}

export interface AvailableUnit {
  id: string
  name: string
  minSqrFt?: string
  maxSqrFt?: string
  floorPlanPicUrl: string
  rentPrices: RentPriceType[]
  maxRentPrice: RentPriceType
  minRentPrice: RentPriceType
  intention: boolean
  availableStatus: number
  preTourEndDate: number
  preTourStartDate: number
  availableStartTime: number
  floorPlanBathroomNum: number
  floorPlanBedroomNum: number
  floorPlanIndex: number
  rooms: RoomType[]
}

export interface AvailableFloorPlan extends AvailableUnit {
  floorPlanId: number
  floorPlanName: string
}

interface BedRoomOptionType {
  key: string
  label: string
  value: string
}
export interface FloorPlanModeUnitType extends AvailableFloorPlan {
  floorPlanIndex: number
  availableUnits: AvailableFloorPlan[]
  bedroomOption: BedRoomOptionType
}

export enum RentalTypeEnum {
  STUDENT_HOUSING = 'StudentHousing',
  STUDENT_FLATSHARE = 'StudentFlatshare',
}

export interface ScheduleTourPropertyType {
  id: string
  aliasName: string
  name: string
  address: string
  headPicUrl: string
  availableStartTime: number
  minPrice: string
  minOriginalPrice: string
  coLivingStatus: 'CO-LIVING' | null
  flexibleLeaseTermTip: string | null
  floorPlanModeUnit: FloorPlanModeUnitType[]
  amenities: { catalogName: string }[]
  rentalType?: RentalTypeEnum | null
}

export interface ScheduleTourTourType {
  id: string
  propertyName: string
  propertyId: string
  status: 'SCHEDULED' | 'FINISHED' | 'CANCELED'
  tourAgentId: string
  tourAgentName: string
  startTime: string
  timeZoneText: string
  timeZone: string
  propertyAddress: string
  preference: string[]
  units: { floorPlanName: string; unitId: number; unitName: string }[]
  tourType: 'IN_PERSON_TOUR' | 'VIRTUAL_TOUR'
  eventId: string
  cancelReason: string
  cancelNote: string
  tourAgentTourDuration: string
  properties: { rentalType: RentalTypeEnum | null; floorPlanName: string; floorPlanId: number; unitId: number; unitName: string }[]
}

export interface PreSelectedUnitInfo {
  propertyId: number
  propertyName: string | null
  roomIds: number[]
  unitId: number
}

export interface SelectedUnitInfoProps {
  floorPlanIndex: number
  unitName: string
  unitTitle: string
  unitId: number
  rooms: {
    unitId: number
    name: string
    id: number
    availableStatus: number
    preTourEndDate: number
    preTourStartDate: number
    availableStartTime: number
  }[]
}

export interface selfGuidTourUnitsProps {
  floorPlanIndex?: number
  floorPlanName: string
  modelUnitId: number
  modelUnitName: string
  units: { unitId: number; unitName: string }[]
}
export interface OtherUnitInfoProps {
  floorPlanIndex: number
  floorPlanName: string
  floorPlanTitle: string
  name: string
}

export type PageTypeType = 'unit' | 'preference' | 'submitTour' | 'tourInfo'
export type SelectedUnitsType = Map<string, { unitsInfo: SelectedUnitInfoProps; otherUnit?: OtherUnitInfoProps }>

export interface SelectedFloorPlanType {
  floorPlanId: number
  floorPlanName: string
}

export const MAX_SELECTED_UNIT = 4
